import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { InlineClassDescriptor2odlvyasjrmr0 as InlineClassDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _GrantedScope___init__impl__tnwe94(asString) {
  return asString;
}
function _GrantedScope___get_asString__impl__oqz3fy($this) {
  return $this;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.root_1 = _GrantedScope___init__impl__tnwe94('*');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function GrantedScope__toString_impl_wb2mw8($this) {
  return _GrantedScope___get_asString__impl__oqz3fy($this);
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.lightningserver.auth.GrantedScope', this);
        tmp0_serialDesc.addElement_5pzumi_k$('asString', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_joz36z_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeString_424b5v_k$(_GrantedScope___get_asString__impl__oqz3fy(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_joz36z_k$(encoder, value instanceof GrantedScope() ? value.asString_1 : THROW_CCE());
      }
      deserialize_9ekr9g_k$(decoder) {
        return _GrantedScope___init__impl__tnwe94(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeString_x3hxsx_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (GrantedScope())(this.deserialize_9ekr9g_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function GrantedScope__hashCode_impl_ajwq3d($this) {
  return getStringHashCode($this);
}
function GrantedScope__equals_impl_wkhjd7($this, other) {
  if (!(other instanceof GrantedScope()))
    return false;
  if (!($this === other.asString_1))
    return false;
  return true;
}
var GrantedScopeClass;
function GrantedScope() {
  if (GrantedScopeClass === VOID) {
    class $ {
      constructor(asString) {
        Companion_getInstance();
        this.asString_1 = asString;
      }
      toString() {
        return GrantedScope__toString_impl_wb2mw8(this.asString_1);
      }
      hashCode() {
        return GrantedScope__hashCode_impl_ajwq3d(this.asString_1);
      }
      equals(other) {
        return GrantedScope__equals_impl_wkhjd7(this.asString_1, other);
      }
    }
    initMetadataForClass($, 'GrantedScope', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    GrantedScopeClass = $;
  }
  return GrantedScopeClass;
}
//region block: exports
export {
  GrantedScope as GrantedScopejxz7dn7szihe,
  $serializer_getInstance as $serializer_getInstance1w32yf0zne1cd,
  Companion_getInstance as Companion_getInstancewd0gqnmrfyoi,
};
//endregion

//# sourceMappingURL=Scope.mjs.map
